import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

import { parseUrlParams } from 'shared/utilities';

export const useUrlParams = <T>(defaultParams: T): T => {
    const location = useLocation();
    return useMemo(() => parseUrlParams(location.search, defaultParams), [location.search]); // eslint-disable-line
};
